import React from 'react';
import styles from './Advantages.module.scss'
import {ReactComponent as Graduation} from "./../../images/graduation.svg";
import {ReactComponent as Flag} from "./../../images/flag-2.svg";
import {ReactComponent as Legal} from "./../../images/legal.svg";
import {ReactComponent as Star} from "./../../images/star-01.svg";

const Advantages = () => {
    return (
        <div className={styles.container}>
            <div className={styles.textBlock}>
                <h2 className={styles.title}>ЧТО ПОЛУЧАЮТ УЧАСТНИКИ, <br/>ПРОШЕДШИЕ ОТБОР</h2>
            </div>
            <div className={styles.cardModule}>
                <div className={styles.card}>
                    <Graduation/>
                    <p className={styles.text}>Обучение современным методам и технологиям управления, личностное
                        развитие</p>
                </div>

                <div className={styles.card}>
                    <Star/>
                    <p className={styles.text}>Персональное наставничество</p>
                </div>

                <div className={styles.card}>
                    <Legal/>
                    <p className={styles.text}>Включение в резерв управленческих кадров региона</p>
                </div>

                <div className={styles.card}>
                    <Flag/>
                    <p className={styles.text}>Работа в органах государственной и муниципальной власти региона,
                        системе патриотического воспитания и работы с молодежью, в реальном секторе экономики</p>
                </div>
            </div>
        </div>
    )
};

export default Advantages;